import Swiper, {Autoplay, Pagination} from "../../assets/.npm/node_modules/swiper";

export default () => {
  let swiperSlider = new Swiper(".js-slider", {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    loop: true,
    navigation: false,
    pagination: {
      el: ".slider-pagination",
      clickable: true,
    },
  });
}
  
